import http from "./http";
import useLocalStorage from "@/composables/storage/useLocalStorage.js";
import useErrorHandling from "./useErrorHandling";
import { useGlobalStore } from "@/stores/globalStore";

export default () => {
  const { checkLocalStorage, bindLocalStorage } = useLocalStorage();
  const { handleServerErrors } = useErrorHandling();

  const fetchAuthToken = async () => {
    const globalStore = useGlobalStore();
    let authToken = await checkLocalStorage("token");

    if (authToken) {
      globalStore.$state.token = authToken;
      return authToken;
    }

    if (globalStore.$state.fetchingToken) {
      authToken = await waitUntilTokenRetrieved();
    } else {
      globalStore.$state.fetchingToken = true;
      await http.get("/csrf-cookie").catch((err) => {
        handleServerErrors(err);
      });

      authToken = await getToken();

      globalStore.$state.fetchingToken = false;
    }

    globalStore.$state.token = authToken;
    return authToken;
  };

  const getToken = async () => {
    return http
      .get("/token")
      .then((response) => {
        bindLocalStorage("token", response.data.bearer_token);
        return response.data.bearer_token;
      })
      .catch((err) => {
        handleServerErrors(err);
      });
  };

  const waitUntilTokenRetrieved = async () => {
    const res = await new Promise((resolve) => {
      const checkInterval = setInterval(() => {
        const authToken = checkLocalStorage("token");
        if (authToken) {
          resolve(authToken);
          clearInterval(checkInterval);
        }
      }, 250);
    });

    return res;
  };

  return {
    // token,
    fetchAuthToken,
  };
};
